import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { history } from '../store'
import { Button } from 'reactstrap'
import { updateQR } from '../actions/qrs'

class QRList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      filters: {
        code: '',
        customer: '',
      },
      showButton: false,
      buttonPosition: { x: 0, y: 0 },
      selectedURL: null
    };

    this.handleRightClick = this.handleRightClick.bind(this);
    this.handleEnabledToggle = this.handleEnabledToggle.bind(this);
  }

  goTo(id, e) {
    history.push(`/qrs/${id}`)
  }

  handleEnabledToggle(qr, e) {
    e.stopPropagation();
    const { updateQR } = this.props;
    const newEnabledValue = !qr.Enabled;
    updateQR(qr._id, { Enabled: newEnabledValue });
  }

  handleFilterChange(filterKey, value) {
    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        [filterKey]: value,
      },
    }));
  }

  returnQrType(type) {

    switch (type) {
      case 'pay': return 'Pago';
      case 'free': return 'Gratis';
      case 'test': return 'Test';
    }

  }

  returnQrMode(mode) {

    switch (mode) {
      case 0: return 'MTO DIARIO';
      case 1: return 'OTO DIARIO SIN PIN';
      case 2: return 'BAQUEIRA';
      case 3: return 'OTO DIARIO CON PIN';
      case 4: return 'RESERVA ANTICIPADA';
    }

  }

  handleRightClick(e, url) {
    e.preventDefault();
    const elementRect = e.target.getBoundingClientRect();
    this.setState({
      showButton: true,
      buttonPosition: {
        x: elementRect.left + window.scrollX,
        y: elementRect.top + window.scrollY,
      },
      selectedURL: url,
    });
  }

  openURL(url, e) {
    e.stopPropagation();
    if (url) {
      window.open(url, '_blank'); // Open the URL in a new tab
    }
  }

  hideButton = () => {
    this.setState({ showButton: false, selectedURL: null });
  }

  handleButtonClick = () => {
    const { selectedURL } = this.state;
    if (selectedURL) {
      // Copy the URL to the clipboard
      navigator.clipboard.writeText(`${selectedURL}`)
        .then(() => {
        })
        .catch(err => {
        });

      this.hideButton(); // Hide the button after clicking
    }
  }

  render() {
    const { filters } = this.state;
    const { qrs } = this.props;

    // Apply the filters to filter the qrs array
    const filteredqrs = qrs.filter(qr => {
      const { code: codeFilter, customer: customerFilter } = filters;

      if (
        codeFilter &&
        (!qr.Code ||
          !qr.Code.toLowerCase().includes(codeFilter.toLowerCase()))
      ) {
        return false;
      }

      if (
        customerFilter &&
        (!qr.Customer.Fullname ||
          !qr.Customer.Fullname.toLowerCase().includes(customerFilter.toLowerCase()))
      ) {
        return false;
      }

      // If all conditions pass, include the customer in the filtered list
      return true;
    });

    return (
      <div className="table-responsive">
        <table className="table table-hover table-clickable">
          <thead className="thead-dark">
            <tr>
              <th scope="col">Código</th>
              <th scope="col">Habilitado</th>
              <th scope="col">Cliente</th>
              <th scope="col">Zona</th>
              <th scope="col">Tipo</th>
              <th scope="col">Modo</th>
              <th scope="col">Ventas</th>
              <th scope="col">Personalización</th>
              <th scope="col">Url</th>
            </tr>
            <tr>
              <th scope="col">
                <input
                  type="text"
                  placeholder="Code"
                  value={filters.code}
                  onChange={e => this.handleFilterChange('code', e.target.value)}
                />
              </th>
              <th scope="col"></th>
              <th scope="col">
                <input
                  type="text"
                  placeholder="Cliente"
                  value={filters.customer}
                  onChange={e => this.handleFilterChange('customer', e.target.value)}
                />
              </th>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {filteredqrs
              .sort((a, b) => {
                // Ensure Fullname is compared in a case-insensitive manner
                const fullnameA = a.Customer.Fullname.toLowerCase();
                const fullnameB = b.Customer.Fullname.toLowerCase();
                if (fullnameA < fullnameB) return -1;
                if (fullnameA > fullnameB) return 1;
                return 0;
              })
              .map(qr => (
                <tr key={qr.Code}
                  onClick={e => this.goTo(qr._id, e)}
                  onContextMenu={(e) => this.handleRightClick(e, qr.Url)}>
                  <th scope="row">{qr.Code}</th>
                  <td scope="row" onClick={(e) => e.stopPropagation()}>
                    <div
                      onClick={(e) => this.handleEnabledToggle(qr, e)}
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        backgroundColor: qr.Enabled ? '#28a745' : '#dc3545',
                        borderRadius: '25px',
                        padding: '4px',
                        cursor: 'pointer',
                        width: '80px',
                        height: '32px',
                        position: 'relative',
                        transition: 'background-color 0.3s ease',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                      }}
                      title={qr.Enabled ? 'Click para deshabilitar' : 'Click para habilitar'}
                    >
                      <div
                        style={{
                          position: 'absolute',
                          backgroundColor: 'white',
                          borderRadius: '50%',
                          width: '24px',
                          height: '24px',
                          transition: 'transform 0.3s ease',
                          transform: qr.Enabled ? 'translateX(50px)' : 'translateX(2px)',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
                        }}
                      />
                      <span
                        style={{
                          color: 'white',
                          fontSize: '11px',
                          fontWeight: 'bold',
                          position: 'absolute',
                          left: qr.Enabled ? '8px' : 'auto',
                          right: qr.Enabled ? 'auto' : '8px',
                          userSelect: 'none',
                        }}
                      >
                        {qr.Enabled ? 'SÍ' : 'NO'}
                      </span>
                    </div>
                  </td>
                  <td scope="row">{qr.Customer.Fullname}</td>
                  <td scope="row">Zona {qr.Zone}</td>
                  <td scope="row">{this.returnQrType(qr.Type)}</td>
                  <td scope="row">{this.returnQrMode(qr.Mode)}</td>
                  <td scope="row">{qr.LastSale}</td>
                  <td scope="row">
                    {qr.headerConfig ? (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        {/* Gradient preview */}
                        <div
                          style={{
                            width: '30px',
                            height: '20px',
                            background: `linear-gradient(to right, ${qr.headerConfig.primaryColor || '#01315f'}, ${qr.headerConfig.secondaryColor || '#067ddb'})`,
                            borderRadius: '3px',
                            border: '1px solid #ddd',
                          }}
                          title="Gradiente Header"
                        />
                        {/* Background color preview */}
                        <div
                          style={{
                            width: '20px',
                            height: '20px',
                            backgroundColor: qr.headerConfig.backgroundColor || '#f3f3f3',
                            borderRadius: '3px',
                            border: '1px solid #ddd',
                          }}
                          title="Color de Fondo"
                        />
                        {/* Logo indicator */}
                        {qr.headerConfig.logoBase64 && (
                          <i className="fas fa-image" style={{ fontSize: '14px', color: '#888' }} title="Tiene Logo" />
                        )}
                        {/* Background image indicators */}
                        {(qr.headerConfig.backgroundImage || qr.headerConfig.backgroundSmartphoneImage) && (
                          <i className="fas fa-picture-o" style={{ fontSize: '14px', color: '#888' }} title="Tiene Imagen de Fondo" />
                        )}
                      </div>
                    ) : (
                      <span style={{ color: '#999', fontSize: '12px' }}>-</span>
                    )}
                  </td>
                  <td scope="row">
                    <button
                      className="btn btn-vw mb-3"
                      onClick={(event) => this.openURL(qr.Url, event)}
                    >
                      <i className="fas fa-link"></i>
                      <span className="d-none d-sm-inline ml-1">Abrir</span>
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
        {this.state.showButton && (
          <div
            style={{
              position: 'absolute',
              top: `${this.state.buttonPosition.y - 200}px`,
              left: `${this.state.buttonPosition.x - 200}px`,
              zIndex: 1000,
            }}
          >
            <Button
              color="primary"
              className={`btn-baqueira`}
              onClick={() => {
                this.handleButtonClick(); // Handle blocked locker logic
              }}
            >
              <i className="fas fa-door-open d-block ml-auto mr-auto mb-2"></i>
              Copiar URL
            </Button>
            <Button
              color="secondary"
              className={`btn-baqueira`}
              onClick={() => {
                this.hideButton(); // Hide button after action
              }}
            >
              <i className="fas fa-times d-block ml-auto mr-auto mb-2"></i>
              Cancelar
            </Button>
          </div>
        )}
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateQR: bindActionCreators(updateQR, dispatch),
});

export default connect(null, mapDispatchToProps)(QRList)